import _some from "lodash/some";
import _get from "lodash/get";
import { CURRENT_TU_TOS_VERSION } from "../constants";
export var getTUTOSAcknowledged = function getTUTOSAcknowledged(identity) {
  var tosAcks = _get(identity, 'profiles.terms_of_service_profile.tos_acknowledgements');

  return _some(tosAcks, function (ack) {
    if (_get(ack, 'version') === CURRENT_TU_TOS_VERSION && _get(ack, 'type') === 'CREDIT_SCORE') {
      return true;
    }
  });
};